import React, { useState, useEffect} from "react";
import Modal from 'react-bootstrap/Modal';
import MapView from "./Modal Body/MapView";
import moment from "moment";
import swal from "sweetalert";
import { Link, useHistory } from "react-router-dom";
import { Button, Tab, Tabs } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addTimelineAction, deleteAcccountReducerAction, deleteDataUsingFormData, ExportDownloadReducerAction, ExportXLSXDownloadReducerAction, ExportZipDownloadReducerAction, FetchSingleRecordAction, FetchSingleRecordAction2, getMOPInstructionAction, popUpUpdate } from "../../../store/actions/createTicketManageFields";
import CommonModal from "./CommonModal";
import { baseURL, mobileDatacoptl,addSiteTimelineData } from "../../../common/config";
import Download from "../../../icons/Svg/Download";
import { useForm } from "react-hook-form";
import SiteTimeLineForm from "./Site Timeline Form/SiteTimeLineForm";
import SiteTimelineCommentEdit from "./Site Timeline Comment Edit/SiteTimelineCommentEdit";
import SiteTimelineTable from "./Site Timeline Table/SiteTimelineTable";

const CustomeModal = ({ranSupportItem, siteDetail, Header, xlShow, filteredMapData, setXlShow, Body, tableHeader, tableHeaderSecond, uniqueId, selectedId, work, modalSize, ctr, mapdata, nestDetail, callFunction }) => {
  console.log("the data is =", siteDetail?.ndResult?.siteId, Header, xlShow, filteredMapData, setXlShow, Body, tableHeader, tableHeaderSecond, uniqueId, selectedId, work, modalSize, ctr, mapdata, nestDetail, callFunction)
  console.log("the site details id =", tableHeaderSecond)
  console.log("filteredMapData id =", filteredMapData)
  console.log("the swork", work)
  const history = useHistory()
  let currentUrl = window.location.href
  currentUrl = currentUrl.split("/")
  let isOpen = currentUrl.pop()


  console.log(ranSupportItem,"___ranSupportItem___common")

  const count = useSelector((state) => {
    console.log(state, "statestatestate")

    let allData = state.CommonResponse.mobileDataCopTimeline
    return { allData }
  })

  



  const [commonModalState, setcommonModalState] = useState(false);
  const [commonModalSize, setcommonModalSize] = useState(false);
  const [commonModalBody, setcommonModalBody] = useState("");
  const [commonModalTitle, setcommonModalTitle] = useState("");
  const [commonModalHeader, setcommonModalHeader] = useState("");


  const[siteTimelineTable, setSiteTimelineTable] = useState(false)
 

  const [oneimgcommonModalState, setoneimgcommonModalState] = useState(false);
  const [oneimgcommonModalSize, setoneimgcommonModalSize] = useState(false);
  const [oneimgcommonModalBody, setoneimgcommonModalBody] = useState("");
  const [oneimgcommonModalTitle, setoneimgcommonModalTitle] = useState("");
  const [oneimgcommonModalHeader, setoneimgcommonModalHeader] = useState("");
  const [downUrl, setdownUrl] = useState("");

  const [popissue, setpopissue] = useState(false);
  const [closer, setCloser] = useState(false);
  console.log("the is open", isOpen == "open")
  console.log(commonModalState,"____commonModalState_____")

  const dispatch = useDispatch();

  const CommonimgModalFun = (body, title, header, type = "md") => {
    setoneimgcommonModalState(true);
    setoneimgcommonModalSize(type);
    setoneimgcommonModalTitle(title);
    setoneimgcommonModalBody(body);
    setoneimgcommonModalHeader(header);
  }

  const downloadFile = (url) => {
    console.log(count.allData.timeline, "count.allData")
    // setdownUrl(count.allData.timeline)
    dispatch(ExportDownloadReducerAction(url, siteDetail?.ndResult?.siteId + "_" + moment(new Date()).format("MMDDYYYYHHMMSS"), "zip"))

  }

  console.log(ranSupportItem,"_____ranSupportItem_______")

  // delete site timeline data start here
  const deleteSiteTimeline = (id,timelineId) => {

    

    swal({
      title: "Are you sure?",
      // text: "Once deleted, you will not be able to recover this imaginary file!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        console.log(timelineId,"timelineIdtimelineId")
        dispatch(deleteAcccountReducerAction(addSiteTimelineData+"/"+id, timelineId));
        // window.location.reload();
      }
    });
  };
  
  // delete site timeline data start here


  // time difference calculationf for site time line start here

  
  const getTimeDifference = (postCheckDelivered,zeroIndexTime) => {
    
    const deliveredTimeString = postCheckDelivered.split(" ")[1];

    
    const deliveredTime = new Date(`1970-01-01T${deliveredTimeString}:00`);

    
    const timeString = new Date(`1970-01-01T${new Date('1970-01-01 ' + zeroIndexTime).toTimeString().slice(0, 5)}:00`);

    
    const differenceInMillis = deliveredTime - timeString;


    const differenceInMinutes = Math.floor(differenceInMillis / (1000 * 60));
    const hours = Math.floor(differenceInMinutes / 60);
    const minutes = differenceInMinutes % 60;

    return `${hours}:${minutes}`;
  };

  // time difference calculationf for site time line ends here



  // add site timline code start here
  const [activityTimelineOptions, setActivityTimelineOptions] = useState([]);
  const [activityTimeId, setActivityTimeId] = useState("");

  const siteTimeline = useSelector((state) => {
    console.log(state, "statestatestate")

    let timelineData = state.CommonResponse.addSiteTimelineData
    return { timelineData }
  })


  console.log(siteTimeline?.timelineData,"______siteTimeline______")
  
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    watch,
    reset,
    formState: { errors },
  } = useForm({});



  


  








// add site timline code ends here
console.log(siteTimeline?.timelineData,"______sitetimelineDaa____")
console.log(siteTimeline,"______sitetimelineDa111111a____")


// edit Comment in Site timeLine Data logic start here



// edit Comment in Site timeLine Data logic start here

  const CommonModalFun = (body, title, header, type = "md") => {
    let data;
    console.log(count.allData, "allData.timeline")

    // let siteTimelineStaticData = timelineDataTable.map((item, index) => (
    //   // <tr key={index}>
    //      <>
    //     <td style={{ border: "2px solid black" }}>{item.id}</td>
    //     <td style={{ border: "2px solid black" }}>{item.team}</td>
    //     <td style={{ border: "2px solid black" }}>{item.activity}</td>
    //     </>
        
    // ))

      

    if (title == "Timeline") {

      let totalTime=""
      let odata = count?.allData?.timeline?.map((oneitm, index) => {
        const timeOnly = new Date(oneitm.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

        console.log(oneitm.text, oneitm, "oneitmCommonModalFunq")
        return <tr>
          <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
            {index + 1}
          </td>
          <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
            {oneitm.text}
          </td>
          <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
            {timeOnly}
          </td>
          <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
            {oneitm.comment  }
          </td>
          
          </tr>
      })
      console.log(odata, "odataodata")
      data = <>
        <h4>TIMELINE</h4>
       
        <table className="table">
          <thead>
            <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>S.No.</td>
            <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Value</td>
            <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Time</td>
          </thead>
          <tbody>
            {odata}
          </tbody>?
        </table>
      </>
    }
      let zeroIndexTime = ""
      
    if (title == "Site Timeline") {


 
      let totalTime=""
//       let odata = siteTimeline?.timelineData?.map((oneitm, index) => {
//         // const timeOnly = new Date(oneitm.time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
//         const dateObj = new Date(oneitm.time);
//         const timeOnly = dateObj.toLocaleTimeString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
//         // const timeOnly = dateObj.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });

// // console.log(`Time: ${timeOnly}, Date: ${dateOnly}`);

//         if( oneitm === 0)
//         {
//           zeroIndexTime=timeOnly
//         }
//           console.log(zeroIndexTime,"____zeroIndexTime____")
//           console.log(oneitm?._id?.$oid,"___oid_____")
//         console.log(oneitm.text, oneitm, "oneitmCommonModalFunq")
        
//         // if(index !== 0){
//           return <tr>

//           <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//             {oneitm?.order }
//           </td>
//           <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//             {oneitm.team}
//           </td>
//           <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//             {oneitm.activityTimeline}
//           </td>
          
          

//           {/* <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//           <button
//           onClick={(e) => { setEditSiteTimelineTime(true);
//             let id = siteTimeline?.timelineData[0]?.parentId+"/"+oneitm._id;
//             setActivityTimeId(id);
//             // setActivityTimeId(siteTimeline?.timelineData[0]?.parentId); 
//             setActivityTimeline(oneitm.activityTimeline)
//             console.log(oneitm?.parentId,"____parentId______")}}
//                 className="badge badge-success p-2"
//                 style={{ fontSize: "10px", lineHeight: "13px" }}
//               >
//                  {oneitm?.time }
//               </button>
           
//           </td>
//            */}
//            <td style={{ width: "30%", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//               <button
//                 onClick={(e) => {
//                   localStorage.setItem("activityTimeId",activityTimeId);
//                   setEditSiteTimelineTime(true);
//                   let id = siteTimeline?.timelineData[0]?.parentId + "/" + oneitm._id;
//                   setActivityTimeId(id);
//                   setActivityTimeline(oneitm.activityTimeline);
//                   console.log(oneitm?.parentId, "____parentId______");
//                 }}
//                 className="badge badge-success p-2"
//                 style={{ fontSize: "10px", lineHeight: "13px" }}
//               >
//                 {oneitm?.time && !isNaN(new Date(oneitm.time)) ? (
//                   (() => {
//                     const date = new Date(oneitm.time);
//                     const formattedDate = date.toLocaleDateString("en-US", {
//                       month: "2-digit",
//                       day: "2-digit",
//                       year: "numeric",
//                     });
//                     const formattedTime = date.toLocaleTimeString("en-US", {
//                       hour: "2-digit",
//                       minute: "2-digit",
//                       hour12: false
//                     });
//                     return `${formattedDate} ${formattedTime} CST`;
//                   })()
//                 ) : (
//                   "Select Time"
//                 )}
//               </button>
//             </td>



//           <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
//           <button
//           onClick={(e) => {

//             const id = siteTimeline?.timelineData[0]?.parentId+"/"+oneitm._id;
//             setActivityTimeId(id);
//             setActivityTimeline(oneitm.activityTimeline) 
            
//              setEditSiteTimelineComment(true);
//             console.log(oneitm?._id,"_oneitm____")
//             // setId((oneitm)=>
//             //   oneitm?._id);
//             // setIdAndOrder(()=>{
//             //   return {
//             //     order:oneitm?.order,
//             //     id:oneitm?._id
//             //   }
//             // })
//             // setActivityTimeId(siteTimeline?.timelineData[0]?.parentId); 
           
//             console.log(oneitm?.parentId,"____parentId______")}}
//                 className="badge badge-success p-2"
//                 style={{ fontSize: "10px", lineHeight: "13px" }}
//               >
//                  {oneitm.comment ? oneitm.comment:"No Comment"}
//               </button>
            
//           </td>
//           <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>

//           <div style={{ display: "inline-flex", gap: "5px", marginLeft: "5px" }}>
//   <button
//     onClick={(e) => { 
//       setcommonModalStateTimeline(true);
    
//       setIdAndOrder(()=>{
//               return {
//                 order:oneitm?.order,
//                 previousId:oneitm?._id
//               }
//             });
//      }}
    
//     className="badge badge-success p-2"
//     style={{ fontSize: "10px", lineHeight: "13px" }}
//   >
//     +
//   </button>

//   <Link
//     href="#"
//     className="btn btn-danger shadow btn-xs sharp d-flex justify-content-center align-items-center p-2"
//     // onClick={() => deleteSiteTimeline(oneitm.parentId, oneitm?._id?.$oid)}
//     onClick={() => deleteSiteTimeline(oneitm.parentId, oneitm?._id)}
//     style={{ display: "inline-flex", alignItems: "center", justifyContent: "center" }}
//   >
//     <i className="fa fa-trash"></i>
//   </Link>
// </div>

//           </td>

          
          
          
//           </tr>
//         // }
//       })
      // console.log(odata, "odataodata")
      // data = <>
      //   {/* <h4>TIMELINE</h4> */}
      //   {siteTimeline?.timelineData?.data?.length === 0 && <button
      //     style={{
      //       backgroundColor: "#143b64",
      //       color: "white",
      //       padding: "10px 20px",
      //       border: "none",
      //       borderRadius: "5px",
      //       cursor: "pointer",
      //       marginBottom: "15px"
      //     }}
      //     // onClick={() => console.log("Button Clicked")}
      //     onClick={(e) => { setcommonModalStateTimeline(true)}}
      //   >
      //     Add Site Timeline
      //   </button>  }
        
      //   <table className="table">
      //     <thead>
      //       <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>S.No.</td>
      //       <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Team</td>
      //       <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Activity Timeline</td>
      //       <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Time</td>
      //       <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Comment</td>
      //       <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Action</td>
      //     </thead>
      //     <tbody>
      //       {/* {siteTimelineStaticData} */}
      //       {odata}


      //     {/* {timelineDataTable.map((item, index) => (
      //     <tr key={index}>
      //       <td style={{ border: "2px solid black" }}>{item.id}</td>
      //       <td style={{ border: "2px solid black" }}>{item.team}</td>
      //       <td style={{ border: "2px solid black" }}>{item.activity}</td>
      //       <td style={{ border: "2px solid black" }}>
              
      //       </td>
      //       <td style={{ border: "2px solid black" }}></td>
      //     </tr>
      //   ))} */}


      //     </tbody>?
      //   </table>
      //   {/* <h4>
      //     TOTAL ACTIVITY TIME (hrs) - 
      //     {ranSupportItem?.postCheckDelivered && zeroIndexTime 
      //       ? getTimeDifference(ranSupportItem?.postCheckDelivered, zeroIndexTime) 
      //       : "N/A"}
      //   </h4> */}
      // </>
    }

    if (title == "COP Details") {

      // let odata=""
      let pre = [];
      let post = [];
      count?.allData?.eosImageData?.map((oneitm, index) => {
        console.log(oneitm.text, oneitm.time, "oneitmCommonModalFun")
        if (oneitm["_id"] == "Pre") {
          // pre.push(
          pre = oneitm.eosdata.map((oneeos, index) => {

            console.log(oneeos)
            return <tr>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {index + 1}
              </td>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {oneeos.result}
              </td>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {/* {} */}
                <div onClick={(e) => {
                  CommonimgModalFun(<><img src={baseURL + oneeos.filePath} style={{ "width": "100%" }}></img></>, oneeos.result + " Image Preview", oneeos.result + " Image Preview", "")
                }}><a className="badge badge-success"><Download /></a></div>
                {/* <a href= {baseURL+oneeos.filePath} target="_blank" className ="badge badge-success" download><Download/></a> */}
              </td>
            </tr>
          })
          // )
        } else {
          post = oneitm.eosdata.map((oneeos, index) => {
            return <tr>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {index + 1}
              </td>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {oneeos.result}
              </td>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>
                {/* {oneeos.filePath} */}

                <div onClick={(e) => {
                  CommonimgModalFun(<><img src={baseURL + oneeos.filePath} style={{ "width": "100%" }}></img></>, oneeos.result + " Image Preview", oneeos.result + " Image Preview", "")
                }}><a className="badge badge-success"><Download /></a></div>

                {/* <a href= {baseURL+oneeos.filePath} target="_blank" className ="badge badge-success" download><Download/></a> */}
              </td>
            </tr>
          })
        }
      })

      console.log(post, pre, "odataodata")
      data = <>
        {/* <div className="row"> */}
        <div className="col-md-6" style={{ float: "left" }}>
          <h4>COP PRE</h4>
          <table className="table">
            <thead>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>S.No.</td>
              <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>COP</td>
              <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Image</td>
            </thead>
            <tbody>
              {pre}
            </tbody>
          </table>
        </div>
        <div className="col-md-6" style={{ float: "right" }}>
          <h4>COP POST</h4>
          <table className="table">
            <thead>
              <td style={{ width: "30%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>S.No.</td>
              <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>COP</td>
              <td style={{ width: "35%;", paddingTop: "11px", fontSize: "13px", height: "45px", border: "2px solid black" }}>Image</td>
            </thead>
            <tbody>
              {post}
            </tbody>
          </table>
        </div>
        {/* </div> */}
      </>
    }



    console.log(count.allData.eosImageData, data, count.allData.timeline, "countcountcountcountallDataallData")
  
    setcommonModalState(true);
    setcommonModalSize(type);
    dispatch(popUpUpdate({}));
    setCloser(true);
    setpopissue(true);
    setcommonModalTitle(title);
    setcommonModalBody(data);
    setcommonModalHeader(header);


  };




  










  return (

    <>
    {/* Add Time for Site time line modal starts here */}

    {/* <SiteTimeLineForm setcommonModalState={setcommonModalState} setcommonModalStateTimeline = {setcommonModalStateTimeline} activityTimeline={activityTimeline} activityTimeId={activityTimeId} modalSize="md" Header="Edit Time" editSiteTimelineTime={editSiteTimelineTime} setEditSiteTimelineTime={setEditSiteTimelineTime} />

    <SiteTimelineCommentEdit setcommonModalState={setcommonModalState} setcommonModalStateTimeline = {setcommonModalStateTimeline} activityTimeline={activityTimeline} activityTimeId={activityTimeId} modalSize="md" Header="Edit Comment" editSiteTimelineComment={editSiteTimelineComment} setEditSiteTimelineComment={setEditSiteTimelineComment} /> */}

        <SiteTimelineTable ranSupportItem={ranSupportItem} siteTimelineTable={siteTimelineTable} setSiteTimelineTable={setSiteTimelineTable} modalSize="xl" Header="Site Timeline"/>

    {/* <Modal
        size={modalSize ? modalSize : "xl"}
        show={editSiteTimelineTime}
        onHide={() => setEditSiteTimelineTime(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">{Header}</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                setEditSiteTimelineTime(false)
            
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white", padding: "0px !important" }}>
        <div>
       <form onSubmit={handleSubmit(onSubmit2)}> 
        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            Time 
                            </label>
                          <input
                          type="time"
                            className="form-control"
                            style={{ height: "32px" }}
                            placeholder="Comment Here"
                            {...register("time", {
                             
                            })}
                          />

                        
                        </div>

        <div className="py-3 d-flex justify-content-center align-items-center">
          <button type="submit" className="btn btn-primary btn-xs ">
            Submit
          </button>

        </div>
      </form>
    </div>
        </Modal.Body>
      </Modal> */}


    {/* Add Time for Site time line modal e ds here */}




      {/* Add site TImeline modal starts here */}
      {/* <Modal
        size={modalSize ? modalSize : "xl"}
        show={commonModalStateTimeline}
        onHide={() => setcommonModalStateTimeline(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">Add Site Timeline</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                setcommonModalStateTimeline(false)
            
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white", padding: "0px !important" }}>
        <div>
       <form onSubmit={handleSubmit(onSubmit)}>
       <div className="form-group">
                                <label htmlFor="exampleInputEmail1">
                                  Team<span style={{ color: "red" }}>*</span>
                                </label>
                                <select
                                  style={{ height: "32px" }}
                                  className="form-control"
                                  id="exampleFormControlSelect1"
                                  placeholder="None Selected"
                                {...register("team")}
                                >
                                  <option value={""}>--None Selected--</option>
                                  <option value={"GC"}>GC</option>
                                  <option value={"IX"}>IX</option>
                                  <option value={"FE"}>FE</option>
                                  <option value={"RF"}>RF</option>
                                </select>
                              </div>

        <div className="form-group w-1/2">

           <label for="exampleFormControlSelect1">
             Activity Timeline

           </label>

           <input
                              style={{ height: "32px" }}
                              type="text"
                              className="form-control"
                              id="inputEmail4"
                              name="activityTimeline"
                              
                      
                              {...register("activityTimeline")}
                            />

          {errors.activityTimeline && (
            <p className="error">{errors.activityTimeline.message}</p>
          )}
        </div>
        <div className="form-group col-md-3">
                          <label for="exampleFormControlSelect1">
                            Comment 
                            </label>
                          <input
                            className="form-control"
                            style={{ height: "32px" }}
                            placeholder="Comment Here"
                            {...register("comment", {
                              required: "Please Enter a Comment",
                              pattern: {
                                // value: /^\d{8}$/,
                                message: "Please Enter a Comment"
                              }
                            })}
                          />

                          {errors.comment && (
                            <p className="error">
                              {errors.comment.message}
                            </p>
                          )}
                        </div>

        <div className="py-3 d-flex justify-content-center align-items-center">
          <button type="submit" className="btn btn-primary btn-xs ">
            Submit
          </button>

        </div>
      </form>
    </div>
        </Modal.Body>
      </Modal> */}

      {/* Add site TImeline modal  ends here*/}


      <Modal
        size={modalSize ? modalSize : "xl"}
        show={xlShow}
        onHide={() => setXlShow(false)}
        aria-labelledby="example-modal-sizes-title-xl"
        backdrop="static"
      >
        <Modal.Header className="CommonModalHeader">
          <Modal.Title id="example-modal-sizes-title-xl ">
            <h4 className="CommonModalHeaderHeading">{Header}</h4>
            <Button
              variant=""
              className="close CommonModalClose"
              onClick={() => {
                if (isOpen == "open") {
                  console.log("the nav")
                  history.push("/PAG/Mop/database")
                  dispatch(getMOPInstructionAction([]))
                  console.log("the navigation done")
                  setXlShow(false)
                }
                else {
                  setXlShow(false)
                }
              }}
            >
              <span className="CommonModalClose">&times;</span>
            </Button>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: "white", padding: "0px !important" }}>
          <div className="mt-2">
            {tableHeader ?
              <>

                {console.log("siteDetaillogger", siteDetail)}
                {/* <Tabs
                defaultActiveKey={siteDetail ? siteDetail.cxCrewId? siteDetail.cxCrewId.name?"home":"profile":"profile":""}
                id="fill-tab-example"
                className="mb-3"
                fill
              >
                <Tab eventKey="home" title="CX Crew"> */}
                <Body tableHeader={tableHeader} siteDetail={siteDetail} />
                {/* </Tab>

                {tableHeaderSecond ? <Tab eventKey="profile" title="IX Crew">
                  <Body tableHeader={tableHeaderSecond} crewDetial={siteDetail.ixCrewId ? siteDetail.ixCrewId : null} />
                </Tab> : <></>}
              </Tabs> */}
                <div className="py-3 d-flex justify-content-center align-items-center">
                  <button className="btn btn-xs mt-5 btn-primary mx-1">
                    <Link
                      className="text-white"

                      onClick={(e) => { callFunction("crewInfo", siteDetail.ranSupportId) }}
                    // to={"/PAG/ran/OntheFlyForm/crewInfo/" + siteDetail.ranSupportId}
                    >
                      Handover
                    </Link></button>
                  <button onClick={(e) => { CommonModalFun("COP Details", "COP Details", "COP Details", "lg") }} className="btn btn-xs mt-5 btn-primary mx-1">Cop Details</button>
                  <button onClick={(e) => { CommonModalFun("Timeline", "Timeline", "Timeline", "xl") }} className="btn btn-xs mt-5 btn-primary mx-1">Timeline</button>
                  <button onClick={(e) => { dispatch(FetchSingleRecordAction2(addSiteTimelineData, ranSupportItem["ranSupportId"])); setSiteTimelineTable(true); }} className="btn btn-xs mt-5 btn-primary mx-1">Site Timeline</button>
                  {
                    count?.allData?.mobileCrewimagesdata?.length > 0 ?
                      <button onClick={(e) => { downloadFile(count?.allData?.mobileCrewimagesfilePath) }} className="btn btn-xs mt-5 btn-primary mx-1">Uploaded Image</button>
                      : ""
                  }
                </div>
              </>
              :

              selectedId ?
                <Body selectedId={selectedId} />
                :
                nestDetail ? <Body nestDetail={nestDetail} />
                  :
                  modalSize ?
                    <Body filteredMapData={filteredMapData} mapdata={mapdata} />
                    :
                    work ? <Body id={uniqueId} work={work} ctr={ctr} setXlShow={setXlShow} />
                      : <Body id={uniqueId} ctr={ctr} setXlShow={setXlShow} />


            }
          </div>
        </Modal.Body>
      </Modal>


      <CommonModal
        modalSize={commonModalSize}
        setXlShow={setcommonModalState}
        xlShow={commonModalState}
        Body={commonModalBody}
        Header={commonModalHeader}
        Title={commonModalTitle}
      ></CommonModal>

      <CommonModal
        modalSize={oneimgcommonModalState}
        setXlShow={setoneimgcommonModalState}
        xlShow={oneimgcommonModalState}
        Body={oneimgcommonModalBody}
        Header={oneimgcommonModalHeader}
        Title={oneimgcommonModalTitle}
      ></CommonModal>



    </>



  );
};

export default CustomeModal;

